import {
  SupportType,
  availableInHoursMinutesOrDays,
} from "@faire/help-center-utils/lib/dateInTimeZone";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

export const FormattedAvailableTime: React.FC<{
  supportType: SupportType;
  color: string | undefined;
}> = ({ supportType, color }) => {
  const { time, unit } = availableInHoursMinutesOrDays(supportType);
  const isLessThanOneHour = unit === "minutes";
  if (!time) {
    return null;
  }
  if (isLessThanOneHour) {
    return (
      <Typography color={color}>
        <StrictLocalMsg
          defaultMessage="{availableMinTime, plural, one {Available in # min} other {Available in # mins}}"
          description={{
            text: "describe available time in minutes",
            img: "https://cdn.faire.com/fastly/5963b85a3bca2f9f8013d515698d7ae2d6da21a059b4a2e59273bdeba6f04e2e.png",
          }}
          values={{
            availableMinTime: time,
          }}
        />
      </Typography>
    );
  }
  if (unit === "hours") {
    return (
      <Typography color={color}>
        <StrictLocalMsg
          defaultMessage="{availableHourTime, plural, one {Available in # hour} other {Available in # hours}}"
          description={{
            text: "describe available time in hours",
            img: "https://cdn.faire.com/fastly/5963b85a3bca2f9f8013d515698d7ae2d6da21a059b4a2e59273bdeba6f04e2e.png",
          }}
          values={{
            availableHourTime: time,
          }}
        />
      </Typography>
    );
  }
  return (
    <Typography color={color}>
      <StrictLocalMsg
        defaultMessage="{availableDayTime, plural, one {Available in # day} other {Available in # days}}"
        description={{
          text: "describe available time in days",
        }}
        values={{
          availableDayTime: time,
        }}
      />
    </Typography>
  );
};
